export default __webpack_public_path__ + "static/media/nederfox.1768cf7d.png";